/**
 * システムファイル
 */
import Repository from "./systemRepository";

const resource = "";
export default {
  /**
   * TM最新観測時刻ファイル取得
   */
  getLatestTmObsTime() {
    return Repository.get(`${resource}/tmCrntTime.json`);
  },
  /**
   * 河川予警報最新時刻ファイル取得
   */
  getLatestRwTime() {
    return Repository.get(`${resource}/rwCrntTime.json`);
  },
};
